import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { colors } from '../themes/colors';

const styles = () => ({
  settingsRow: {
    marginBottom: 20,
  },
  fieldHeader: {
    color: colors.black2,
  },
});

const SettingsRow = ({ classes, title, children }) => (
  <div className={classes.settingsRow}>
    <Typography variant="body1" className={classes.fieldHeader}>
      {title}
    </Typography>
    {children}
  </div>
);

export default withStyles(styles)(SettingsRow);
